import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormattedPhoneNumber } from './FormattedPhoneNumber'
import useStyles from './styles'

interface Props {
  phone: string
}

export const NewPatientContent = ({ phone }: Props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <div className={classes.title}>{t('verify_phone_page_title')}</div>
      <div className={classes.info}>
        {t('verify_phone_page_info')} {t('verify_phone_page_sms_code')}{' '}
      </div>
      <div className={classes.phoneNumber}>
        <FormattedPhoneNumber phone={phone} />
      </div>
    </>
  )
}
